import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import * as cloneDeep from "lodash/cloneDeep";

@Component({
    selector: 'child-cell',
    template: `<span><button *ngIf="RequiredEdit" style="margin-top:0px;padding: 1px 3px !important;"  color="link" class="waves-light edit-button  btn btn-sm" (click)="edit()">
    <i class="icon-edit"></i>
</button>
<button *ngIf="RequiredView" style="margin-top:0px;padding: 1px 3px !important;"  color="link" class="waves-light edit-button btn btn-sm" (click)="edit()">
 <i class="fa-solid fa-desktop"></i>
</button>
<button *ngIf="RequiredPolicyView" style="margin-top:0px;padding: 1px 3px !important;"  color="link" class="waves-light edit-button btn btn-sm" (click)="onIndividualClick('RequiredViewIcon')">
 <i class="fa-solid fa-desktop"></i>
</button>
<button *ngIf="RequiredUserIcon"  style="margin-top:0px;padding: 1px 3px !important;"   color="link" class="waves-light edit-button btn btn-sm" (click)="userIconClick()">
 <i class="fas fa-users"></i>
</button>
<button *ngIf="RequiredUploadIcon" title="Update to Latest" style="margin-top:0px;padding: 1px 3px !important;"   color="link" class="waves-light edit-button btn btn-sm" (click)="onIndividualClick('RequiredUploadIcon')">
 <i class="fas fa-upload"></i>
</button>
<div class="btn-group" [matMenuTriggerFor]="menu" *ngIf="oprs?.length && RequiredSettings">
                <button style="margin-top:4px;padding: 1px 3px !important;"  color="link" class="waves-light btn btn-sm" classInside="dropdown-toggle">
                <i class="icon-settings fs-14"></i>
                </button>
                <mat-menu #menu="matMenu">
                <a *ngFor="let operation of oprs | noAddBtnfilter:filterargs" class="mat-dropdown-item" (click)="onOperationClick(operation)" style="padding-top: 0px;padding-bottom: 0px;"  [ngClass]="{'aggrid-menu-item-disabled':(operation.disabled=='true')}">{{operation.name}}</a>
                </mat-menu>
            </div>
</span>`,
    styles: [
    ]
})
export class EditOthersRenderer implements ICellRendererAngularComp {
    public params: any;
    public oprs;
    public RequiredSettings = false;
    public RequiredUserIcon = false;
    public RequiredEdit = false;
    public RequiredView=false;
    public RequiredUploadIcon=false;
    public RequiredPolicyView=false;
    public RequiredSendBackRowData=false;
    filterargs = {name: 'Add'};
    agInit(params: any): void {
        this.params = params;
        if(this.params.context && this.params.context.componentParent ){
            if(params.data["Operations"]){
                this.oprs =params.data["Operations"];// this.params.context.componentParent.operations;
               // this.oprs.reverse(); 
            }
            else{
                this.oprs = this.params.context.componentParent.operations;
            }
        }
        if(this.params.context && this.params.context.componentParent && this.params.context.componentParent.RequiredEdit){
            this.RequiredEdit = true;
        }
        if(this.params.context && this.params.context.componentParent && this.params.context.componentParent.RequiredSettings){
            this.RequiredSettings = true;
        }
        if(this.params.context && this.params.context.componentParent && this.params.context.componentParent.RequiredUserIcon){
            this.RequiredUserIcon = true;
        }
        if(this.params.context && this.params.context.componentParent && this.params.context.componentParent.RequiredView){
            this.RequiredView = true;
        }
        if(this.params.context && this.params.context.componentParent && this.params.context.componentParent.RequiredUploadIcon){
            this.RequiredUploadIcon = true;
        }
        if(this.params.context && this.params.context.componentParent && this.params.context.componentParent.RequiredPolicyView){
            this.RequiredPolicyView = true;
        }
        if(this.params.context && this.params.context.componentParent && this.params.context.componentParent.RequiredSendBackRowData){
            this.RequiredSendBackRowData = true;
        }
    }

    public onOperationClick(operation) {
       // this.params.context.componentParent.onOperationClick(operation)
        ;
       if(this.RequiredSendBackRowData!=true)
       {
        this.params.context.componentParent.onOperationClick(operation,this.params.data)
       }
       else{
        this.params.context.componentParent.onOperationClick(operation.callback(this.params.data))
       }
    }
    public onIndividualClick(type) {
        var Operation= this.oprs.filter((result)=>{
            return result.name==type
           })[0];
           Operation.callback(this.params.data)
    }
    public isPopup(){
        return true;
    }

    public edit(){
        this.params.context.componentParent.editButton();
    }

    public userIconClick()
    {
         ;
        this.params.context.componentParent.userIconClick();
    }

    refresh(): boolean {
        return false;
    }
}

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'noAddBtnfilter',
    pure: false
})

export class NoAddBtnPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.name.indexOf(filter['name']) === -1);
    }
}
